import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, ISC_INV_TRANSFER_URL } from '../../../services/TapApiUrls';
import ItemViewInList from '../includes/ItemViewInList';
import IndentDetailModal from '../warehouseIndent/IndentDetailModal';
import tapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import TapSelect from '../../../components/ui/TapSelect';
import download from '../../../services/DownloadFile';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import DateService from '../../../services/DateService';
import LogisticViewModal from '../logistic/LogisticViewModal';
import InventoryTransferDocument from './InventoryTransferDocument';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';

class InventoryTransferDetail extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.updateCommentFormInit = {
            status: '',
            notes: '',
            date_of_dispatch: '',
            date_of_receive: ''
        }

        this.updateDispatchFormInit = {
            eway_number: '',
            eway_date: '',
            document_number: '',
            document_date: '',
            transporter_number: '',
            vechicle_registration_no: '',
            no_of_boxes: '',
            weight: '',
            unit_of_weight: ''
        }

        this.initRemarkItemFormdata = {
            item_profile: null,
            prev_remark: '',
            remark: '',
            transaction_id: '',
            inventory_transfer_item_id: '',
            inventory_transfer_item_ids: []
        }

        this.state = {
            inventoryData: null,
            inventoryItemId: null,
            view_loading: false,
            detail_loading: false,
            addCommentForm: { ...this.updateCommentFormInit },
            allAllowedStatus: [],
            addCommentFormSubmitting: false,
            pdfDownloading: false,
            updateDispatchForm: { ...this.updateDispatchFormInit },
            updateDispatchFormSubmitting: false,
            remarkItemFormdata: { ...this.initRemarkItemFormdata },
            remarkSubmitting: false,
            approved_indent_listing: false,
            indent_listing: [],
            indent_transaction_id: '',
            allWeightUnits: [{ value: "gm", label: "Gram" }, { value: "kg", label: "KilloGram" }, { value: "tonne", label: "Tonne" }],
            _loadingTransactionId: null,
        };

        // Refs
        this.indentDetailRef = React.createRef();
        this.LogisticViewModalRef = React.createRef();
        this.itemDetailsRef = React.createRef();
        this.commentRef = React.createRef();

        this.inventoryTransferUrl = ISC_INV_TRANSFER_URL;
        this.inventoryTransferListUrl = INVENTORY_API_BASE_URL_2 + '/inventory_transfers';
        this.inventoryTransferReportUrl = INVENTORY_API_BASE_URL_2 + '/report/item-wise-inventory-tranfer';
        this.warehouseIndentItemWiseUrl = INVENTORY_API_BASE_URL_2 + '/warehouse_indent/item_wise';
        this.itemRemarkEditUrl = ISC_INV_TRANSFER_URL + '/item_remark';
        
        // Modal refs
        this.updateDispatchModal = null;
        this.updateRemarkModal = null;
        this.linkIndentModal = null;
        this.inventoryDetailModal = null;

    }

    componentDidMount() {
        // Only initialize modals if not rendering inline
        if (this.props.renderAs !== 'inline') {
            const modalElement = document.getElementById('inventoryDetailModal');
            if (modalElement) {
                this.inventoryDetailModal = new Modal(modalElement, { keyboard: false, backdrop: false });
            }
        }
        
        // Initialize modals
        this.initializeModals();

        if (this.props.transaction_id) {
            this.getInventoryTransferDetail(this.props.transaction_id);
        }
        if (this.props.inventoryId) {
            this.getInventoryTransferDetail(this.props.inventoryId);
        }
    }

    componentDidUpdate(prevProps) {
    const { transaction_id, inventoryId } = this.props;
    const { inventoryItemId, detail_loading, _loadingTransactionId } = this.state;
    
    // Check for transaction_id change
    if (transaction_id && 
        transaction_id !== prevProps.transaction_id && 
        transaction_id !== inventoryItemId &&
        !detail_loading &&
        _loadingTransactionId !== transaction_id) {
        this.getInventoryTransferDetail(transaction_id);
    }
    
    // Check for inventoryId change
    if (inventoryId && 
        inventoryId !== prevProps.inventoryId && 
        inventoryId !== inventoryItemId &&
        !detail_loading &&
        _loadingTransactionId !== inventoryId) {
        this.getInventoryTransferDetail(inventoryId);
    }
    
    // Re-initialize modals if they don't exist
    if (!this.updateDispatchModal || !this.updateRemarkModal || !this.linkIndentModal) {
        this.initializeModals();
    }
}

    initializeModals = () => {
        const dispatchModal = document.getElementById('updateDispatchModal');
        const remarkModal = document.getElementById('updateRemarkModal');
        const linkIndentModal = document.getElementById('linkIndentModal');

        if (dispatchModal && !this.updateDispatchModal) {
            this.updateDispatchModal = new Modal(dispatchModal, { keyboard: false, backdrop: false });
        }
        if (remarkModal && !this.updateRemarkModal) {
            this.updateRemarkModal = new Modal(remarkModal, { keyboard: false, backdrop: false });
        }
        if (linkIndentModal && !this.linkIndentModal) {
            this.linkIndentModal = new Modal(linkIndentModal, { keyboard: false, backdrop: false });
        }
    }

    // Modal init method (for modal mode)
    modalInventoryInit = (transaction_id) => {
        if (this.inventoryDetailModal) {
            this.inventoryDetailModal.show();
        }
        this.getInventoryTransferDetail(transaction_id);
    }

    getInventoryTransferDetail = (transaction_id, forceRefresh = false) => {
        if (!forceRefresh && this.state.inventoryItemId === transaction_id && this.state.inventoryData) {
            return;
        }

        if (this.state.detail_loading || this.state._loadingTransactionId === transaction_id) {
            return;
        }

        this.setState({ 
            detail_loading: true, 
            _loadingTransactionId: transaction_id 
        });

        HttpAPICall.withAthorization('GET', ISC_INV_TRANSFER_URL + '/detail/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            console.log("jjjoood")
            this.setState({
                inventoryData: respData.data,
                inventoryItemId: respData.data.transaction_id,
                allAllowedStatus: respData.data && respData.data.userStatus && respData.data.userStatus.length > 0 ? 
                    respData.data.userStatus.map((s) => { return { value: s.key, label: s.status }; }) : [],
                addCommentForm: { 
                    ...this.updateCommentFormInit, 
                    status: respData.data.status,
                    date_of_dispatch: respData?.data?.date_of_dispatch ?? null,
                    date_of_receive: respData?.data?.date_of_receive ?? null 
                },
                detail_loading: false,
                _loadingTransactionId: null,
            }, () => {
                // After state update, re-initialize modals
                setTimeout(() => {
                    this.initializeModals();
                }, 100);
            });
            if (this.props.onDetailLoaded) {
                this.props.onDetailLoaded(respData.data);
            }
        }).catch(() => {
            this.setState({ 
                detail_loading: false, 
                _loadingTransactionId: null 
            });
        });
    }

    refreshDetail = (transaction_id) => {
        if (transaction_id) {
            this.getInventoryTransferDetail(transaction_id, true);
        } else if (this.state.inventoryItemId) {
            this.getInventoryTransferDetail(this.state.inventoryItemId, true);
        }
    }

    // Scroll to comment section
    scrollToComment = () => {
        if (this.commentRef.current) {
            this.commentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // Update Status
    submitUpdateStatusForm = (e) => {
        e.preventDefault();
        this.setState({ addCommentFormSubmitting: true });
        let frmData = {
            ...this.state.addCommentForm,
            transaction_id: this.state.inventoryItemId
        };

        HttpAPICall.withAthorization('PUT', this.inventoryTransferUrl + '/change_status', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.getInventoryTransferDetail(this.state.inventoryItemId, true);
            if (this.props.onUpdate) {
                this.props.onUpdate();
            }
            this.setState({ addCommentForm: { ...this.updateCommentFormInit } });
        }).then(() => this.setState({ addCommentFormSubmitting: false }));
    }

    // Update Dispatch Detail
    updateDispatchModalInit = () => {
        // Ensure modal is initialized
        if (!this.updateDispatchModal) {
            this.initializeModals();
        }
        
        if (!this.updateDispatchModal) {
            toast.error('Dispatch modal not available', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        
        if (this.state.inventoryData) {
            let detail = this.state.inventoryData;
            this.setState({
                updateDispatchForm: {
                    transaction_id: detail.transaction_id ? detail.transaction_id : '',
                    eway_number: detail.eway_number ? detail.eway_number : '',
                    eway_date: detail.eway_date ? detail.eway_date : null,
                    document_number: detail.document_number ? detail.document_number : '',
                    document_date: detail.document_date ? detail.document_date : null,
                    transporter_number: detail.transporter_number ? detail.transporter_number : '',
                    vechicle_registration_no: detail.vechicle_registration_no ? detail.vechicle_registration_no : '',
                    no_of_boxes: detail.no_of_boxes ? detail.no_of_boxes : '',
                    weight: detail.weight ? detail.weight : '',
                    unit_of_weight: detail.unit_of_weight ? detail.unit_of_weight : '',
                    date_of_dispatch: detail.date_of_dispatch ? detail.date_of_dispatch : '',
                    date_of_receive: detail.date_of_receive ? detail.date_of_receive : ''
                }
            }, () => {
                this.updateDispatchModal.show();
            });
        }
    }

    submitUpdateDispatchForm = (e) => {
        e.preventDefault();
        this.setState({ updateDispatchFormSubmitting: true });
        let frmData = {
            ...this.state.updateDispatchForm,
            transaction_id: this.state.inventoryItemId
        };
        HttpAPICall.withAthorization('PUT', this.inventoryTransferUrl + '/edit_dispatch_detail', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.getInventoryTransferDetail(this.state.inventoryItemId, true);
            if (this.props.onUpdate) {
                this.props.onUpdate();
            }
            this.setState({ updateDispatchForm: { ...this.updateDispatchFormInit } });
            if (this.updateDispatchModal) {
                this.updateDispatchModal.hide();
            }
        }).then(() => this.setState({ updateDispatchFormSubmitting: false }));
    }

    // Update Remarks
    updateRemarksModalInit = (indent_item, item_profile) => {
        // Ensure modal is initialized
        if (!this.updateRemarkModal) {
            this.initializeModals();
        }
        
        if (!this.updateRemarkModal) {
            toast.error('Remarks modal not available', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        
        let transaction_item = indent_item.items[0];
        this.setState({
            remarkItemFormdata: {
                ...this.state.remarkItemFormdata,
                item_profile: item_profile,
                prev_remark: transaction_item.remark,
                remark: transaction_item.remark,
                transaction_id: transaction_item.transaction_id,
                inventory_transfer_item_id: transaction_item.id,
                inventory_transfer_item_ids: indent_item.items.map(i => i.id)
            }
        }, () => {
            this.updateRemarkModal.show();
        });
    }

    handleRemarkForm = (e) => {
        e.preventDefault();
        let { item_profile, inventory_transfer_item_id, transaction_id, remark, prev_remark } = this.state.remarkItemFormdata;

        if (!item_profile) {
            toast.error('Item not found', { position: toast.POSITION.TOP_RIGHT });
        } else if (prev_remark == remark) {
            if (this.updateRemarkModal) {
                this.updateRemarkModal.hide();
            }
        } else {
            this.setState({ remarkSubmitting: true });
            let data = {
                inventory_transfer_item_id: inventory_transfer_item_id,
                transaction_id: transaction_id,
                remark: remark
            };
            HttpAPICall.withAthorization('PUT', this.itemRemarkEditUrl, this.props.access_token, {}, data, (response) => {
                this.getInventoryTransferDetail(transaction_id, true);
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
            }).then(() => {
                if (this.updateRemarkModal) {
                    this.updateRemarkModal.hide();
                }
                this.setState({ remarkSubmitting: false });
            });
        }
    }

    // Download handlers
    downloadPdfHandler = (transaction_id, key) => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', ISC_INV_TRANSFER_URL + '/detail/' + transaction_id, this.props.access_token, { download: key }, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    downloadItemWiseHandler = (transaction_id) => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', this.inventoryTransferReportUrl, this.props.access_token, { action: "download", search_like_transaction_id: transaction_id }, {}, (response) => {
            download.file(null, response.data.msg, response.data.navigation, this.props);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    // Delete
    deleteInventoryTransfer = (transaction_id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', this.inventoryTransferUrl + '/' + transaction_id, this.props.access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    if (this.props.onDelete) {
                        this.props.onDelete();
                    }
                });
            }
        });
    }

    // Edit
    openUpdateInventoryScreen = () => {
        if (this.state.inventoryData) {
            this.props.history.push({ 
                pathname: `/inventory_transfer_list/add`, 
                state: { inventoryTransferData: this.state.inventoryData } 
            });
        }
    }

    // Clone
    cloneInventoryTransfer = () => {
        if (this.state.inventoryData) {
            this.props.history.push({ 
                pathname: `/inventory_transfer_list/add`, 
                state: { inventoryTransferData: { ...this.state.inventoryData, clone: true } } 
            });
        }
    }

    // Add to Consumption
    addToConsumptionModalInit = () => {
        let itemList = [];
        let allocationItemForCheckbox = document.getElementsByClassName('inventory_item_id_checkbox');
        if (allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
            for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                if (allocationItemForCheckbox[i].checked) {
                    let itemId = allocationItemForCheckbox[i].value;
                    let data = this.state.inventoryData.transfer_items.find(i => i.item_profile.id == itemId);
                    itemList.push({ data });
                }
            }
        }
        if (itemList && itemList.length == 0) {
            toast.error('Please select an Item', { position: toast.POSITION.TOP_RIGHT });
        } else {
            let consumptionData = { 
                items: itemList, 
                warehouse_id: this.state.inventoryData.warehouse_to 
            };
            this.props.history.push({ 
                pathname: `/consumption_list/add`, 
                state: { addConsumptionFromInventoryTransfer: consumptionData } 
            });
        }
    }

    // Add to Allocation
    addToAllocationModalInit = () => {
        let itemList = [];
        let allocationItemForCheckbox = document.getElementsByClassName('inventory_item_id_checkbox');
        if (allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
            for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                if (allocationItemForCheckbox[i].checked) {
                    let itemId = allocationItemForCheckbox[i].value;
                    let qty = allocationItemForCheckbox[i].getAttribute("data-purchaseQty");
                    let rate = allocationItemForCheckbox[i].getAttribute("data-totalRate");
                    let data = this.state.inventoryData.transfer_items.find(i => i.item_profile.id == itemId);
                    itemList.push({ 
                        item: data.item_profile, 
                        qty: qty ? qty : 0, 
                        rate: rate ? rate : 0 
                    });
                }
            }
        }
        if (itemList && itemList.length == 0) {
            toast.error('Please select an Item', { position: toast.POSITION.TOP_RIGHT });
        } else {
            let allocationData = { 
                items: itemList, 
                warehouse_id: this.state.inventoryData.warehouse_to 
            };
            this.props.history.push({ 
                pathname: `/allocation_list/add`, 
                state: { addAllocationFromInventoryTransfer: allocationData } 
            });
        }
    }

    // Check all items
    checkAllCancelItem = () => {
        let poItemCollections = document.getElementsByClassName('inventory_item_id_checkbox');
        if (poItemCollections && poItemCollections.length > 0) {
            for (let i = 0; i < poItemCollections.length; i++) {
                poItemCollections[i].checked = document.getElementById('all_check_po').checked;
            }
        }
    }

    // Link to Indent
    linkToIndentInit = () => {
        // Ensure modal is initialized
        if (!this.linkIndentModal) {
            this.initializeModals();
        }
        
        if (!this.linkIndentModal) {
            toast.error('Link indent modal not available', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        
        let itemList = [];
        let indentLinked = [];
        let purchaseQty = [];
        let selectedItemIds = [];
        let allocationItemForCheckbox = document.getElementsByClassName('inventory_item_id_checkbox');
        if (allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
            for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                if (allocationItemForCheckbox[i].checked) {
                    let itemId = allocationItemForCheckbox[i].value;
                    let itemIds = allocationItemForCheckbox[i].getAttribute("data-itemIds");
                    itemList.push(itemId);
                    indentLinked.push(allocationItemForCheckbox[i].getAttribute("data-indentId"));
                    purchaseQty.push(allocationItemForCheckbox[i].getAttribute("data-purchaseQty"));
                    if (itemIds) {
                        selectedItemIds = selectedItemIds.concat(itemIds.split(',').map(Number));
                    }
                }
            }
        }

        let indentList = indentLinked && indentLinked.length > 0 ? indentLinked.filter(indent => indent !== null) : indentLinked;

        if (itemList && itemList.length == 0) {
            toast.error('Please select an Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (itemList && itemList.length > 1) {
            toast.error('Only one Item can be adjusted at a time', { position: toast.POSITION.TOP_RIGHT });
        } else if (indentList && indentList.length >= 1) {
            toast.error('Indent is already Linked with this Item', { position: toast.POSITION.TOP_RIGHT });
        } else {
            this.linkIndentModal.show();
            this.getIndentList(itemList[0], purchaseQty[0], selectedItemIds[0]);
        }
    }

    getIndentList = (item_id, purchase_qty = 0, selected_item_id) => {
        this.setState({ approved_indent_listing: true });
        let obj = { min_purchase_or_pending_qty: purchase_qty, search_transaction_id: this.state.indent_transaction_id };
        let params = {
            search_receiving_warehouse: this.state.inventoryData ? this.state.inventoryData.warehouse_to : "",
            ...obj,
            search_status_ids: [4],
            page: 1,
            search_item_ids: [item_id]
        };
        HttpAPICall.withAthorization('GET', this.warehouseIndentItemWiseUrl, this.props.access_token, { ...params }, {}, (response) => {
            let respData = response.data;
            this.setState({
                indent_listing: respData.data && respData.data.length > 0 ? 
                    respData.data.map(data => ({ ...data, transfer_qty: purchase_qty, warehouse_indent_item_id: selected_item_id })) : [],
            });
        }).then(() => this.setState({ approved_indent_listing: false }));
    }

    checkAllIndentItem = () => {
        let poItemCollections = document.getElementsByClassName('indent_item_id_checkbox');
        if (poItemCollections && poItemCollections.length > 0) {
            for (let i = 0; i < poItemCollections.length; i++) {
                poItemCollections[i].checked = document.getElementById('all_check_indent').checked;
            }
        }
    }

    submitLinkIndentForm = (e) => {
        e && e.preventDefault();
        let indentLinked = [];
        let warehouseIndentId = [];
        let selectedItemIds = [];
        let allocationItemForCheckbox = document.getElementsByClassName('indent_item_id_checkbox');

        if (allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
            for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                if (allocationItemForCheckbox[i].checked) {
                    let id = allocationItemForCheckbox[i].value;
                    indentLinked.push(id);
                    warehouseIndentId.push(allocationItemForCheckbox[i].getAttribute("data-warehouseItemId"));
                    selectedItemIds.push(allocationItemForCheckbox[i].getAttribute("data-warehouseIndentItemId"));
                }
            }
        }

        let indentList = indentLinked && indentLinked.length > 0 ? indentLinked.filter(indent => indent !== null) : indentLinked;
        let warehouseIndent = warehouseIndentId && warehouseIndentId.length > 0 ? warehouseIndentId.filter(indent => indent !== null) : warehouseIndentId;
        let selectedItemId = selectedItemIds && selectedItemIds.length > 0 ? selectedItemIds.filter(indent => indent !== null) : selectedItemIds;

        if (indentList && indentList.length == 0) {
            toast.error('Please select an Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (indentList && indentList.length > 1) {
            toast.error('Only one Item can be Linked at a time', { position: toast.POSITION.TOP_RIGHT });
        } else {
            let frmData = {
                inventory_transfer_item_id: selectedItemId && selectedItemId.length > 0 ? selectedItemId[0] : '',
                warehouse_indent_transaction_id: warehouseIndent[0],
                warehouse_indent_item_id: indentList[0],
                transaction_id: this.state.inventoryItemId,
            };
            HttpAPICall.withAthorization('PUT', this.inventoryTransferUrl + '/item_link_with_indent', this.props.access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.getInventoryTransferDetail(this.state.inventoryItemId, true);
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
                if (this.linkIndentModal) {
                    this.linkIndentModal.hide();
                }
            }).then(() => this.setState({ updateDispatchFormSubmitting: false }));
        }
    }

    // View methods
    viewIndentDetailModalInit = (transaction_id) => {
        if (transaction_id && this.indentDetailRef.current) {
            this.indentDetailRef.current.modalIndentInit(transaction_id);
        }
    }

    viewItemModalInit = (item) => {
        if (item && this.itemDetailsRef.current) {
            this.itemDetailsRef.current.modalInit(item);
        }
    }

    logisticDetailModal = (val) => {
        if (val && this.LogisticViewModalRef.current) {
            this.LogisticViewModalRef.current.showModalInit(val);
        }
    }

    // Form handlers
    formInputHandler = (e, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [e.target.name]: e.target.value
            }
        });
    }

    formDateHandler = (keyName, value, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [keyName]: value ? moment(value).format('YYYY-MM-DD') : null
            }
        });
    }

    tapSelectChange = (selectedOption, formName, fieldName, callback = null) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [fieldName]: selectedOption ? selectedOption.value : ''
            }
        }, callback);
    }

    // Render modals (always rendered, not inside renderDetailContent)
    renderModals = () => {
        return (
            <Ax>
                {/* Update Dispatch Modal */}
                <div className="modal fade" id="updateDispatchModal" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Update Dispatch for: {this.state.inventoryItemId ?? "-"}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form id="updateDispatchForm" onSubmit={this.submitUpdateDispatchForm}>
                                <div className="modal-body">
                                    <div className="row my-3 align-items-center">
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Eway Bill Number</label>
                                        <div className="col-sm-4">
                                            <input
                                                name="eway_number"
                                                type="text"
                                                value={this.state.updateDispatchForm.eway_number}
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                onChange={(e) => this.formInputHandler(e, "updateDispatchForm")}
                                                placeholder="Please enter Eway Bill Number"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Eway Bill Date</label>
                                        <div className="col-sm-4 add_calender_section">
                                            <DatePicker
                                                selected={this.state.updateDispatchForm.eway_date ? moment(this.state.updateDispatchForm.eway_date, 'YYYY-MM-DD').toDate() : false}
                                                name="eway_date"
                                                onChange={(value) => this.formDateHandler('eway_date', value, 'updateDispatchForm')}
                                                dateFormat="dd-MMM-yyyy"
                                                className="form-control form-control-sm"
                                                showMonthDropdown
                                                showYearDropdown
                                                autoComplete="off"
                                                scrollMonthYearDropdown
                                                placeholderText="Please Enter Eway Date"
                                            />
                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" style={{ top: "6px" }} />
                                        </div>
                                    </div>
                                    <div className="row my-3 align-items-center">
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Docket Number</label>
                                        <div className="col-sm-4">
                                            <input
                                                name="document_number"
                                                type="text"
                                                value={this.state.updateDispatchForm.document_number}
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                onChange={(e) => this.formInputHandler(e, "updateDispatchForm")}
                                                placeholder="Please enter Document Number"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Docket Date</label>
                                        <div className="col-sm-4 add_calender_section">
                                            <DatePicker
                                                selected={this.state.updateDispatchForm.document_date ? moment(this.state.updateDispatchForm.document_date, 'YYYY-MM-DD').toDate() : false}
                                                name="document_date"
                                                onChange={(value) => this.formDateHandler('document_date', value, 'updateDispatchForm')}
                                                dateFormat="dd-MMM-yyyy"
                                                className="form-control form-control-sm"
                                                showMonthDropdown
                                                showYearDropdown
                                                autoComplete="off"
                                                scrollMonthYearDropdown
                                                placeholderText="Please Enter Docket Date"
                                            />
                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" style={{ top: "6px" }} />
                                        </div>
                                    </div>
                                    <div className="row my-3 align-items-center">
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Transporter Name</label>
                                        <div className="col-sm-4">
                                            <input
                                                name="transporter_number"
                                                type="text"
                                                value={this.state.updateDispatchForm.transporter_number}
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                onChange={(e) => this.formInputHandler(e, "updateDispatchForm")}
                                                placeholder="Please enter Transporter Name"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Vehicle No</label>
                                        <div className="col-sm-4">
                                            <input
                                                name="vechicle_registration_no"
                                                type="text"
                                                value={this.state.updateDispatchForm.vechicle_registration_no}
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                onChange={(e) => this.formInputHandler(e, "updateDispatchForm")}
                                                placeholder="Please enter Vehicle Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-3 align-items-center">
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Number of Boxes</label>
                                        <div className="col-sm-4">
                                            <input
                                                name="no_of_boxes"
                                                type="number"
                                                value={this.state.updateDispatchForm.no_of_boxes}
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                onChange={(e) => this.formInputHandler(e, "updateDispatchForm")}
                                                placeholder="Please enter Number of Boxes"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm">Weight & Unit</label>
                                        <div className="col-sm-2">
                                            <input
                                                name="weight"
                                                type="number"
                                                value={this.state.updateDispatchForm.weight}
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                onChange={(e) => this.formInputHandler(e, "updateDispatchForm")}
                                                placeholder="Weight"
                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <TapSelect
                                                options={this.state.allWeightUnits}
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'updateDispatchForm', 'unit_of_weight')}
                                                value={this.state.allWeightUnits.find(u => this.state.updateDispatchForm?.unit_of_weight == u.value)}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Unit"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-3 align-items-center">
                                        {(this.state.inventoryData?.status == 35 || this.state.inventoryData?.status == 36) && 
                                            <Ax>
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Date of Dispatch</label>
                                                <div className="col-sm-4">
                                                    <DatePicker
                                                        selected={this.state.updateDispatchForm.date_of_dispatch ? moment(this.state.updateDispatchForm.date_of_dispatch, 'YYYY-MM-DD').toDate() : false}
                                                        name="date_of_dispatch"
                                                        onChange={(value) => this.formDateHandler('date_of_dispatch', value, 'updateDispatchForm')}
                                                        dateFormat="dd-MMM-yyyy"
                                                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                                        className="form-control form-control-sm"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        autoComplete="off"
                                                        scrollMonthYearDropdown
                                                        required={true}
                                                        placeholderText="Please Enter Date of Dispatch"
                                                    />
                                                </div>
                                            </Ax>
                                        }
                                        {(this.state.inventoryData?.status == 36) && 
                                            <Ax>
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Date of Receipt</label>
                                                <div className="col-sm-4">
                                                    <DatePicker
                                                        selected={this.state.updateDispatchForm.date_of_receive ? moment(this.state.updateDispatchForm.date_of_receive, 'YYYY-MM-DD').toDate() : false}
                                                        name="date_of_receive"
                                                        onChange={(value) => this.formDateHandler('date_of_receive', value, 'updateDispatchForm')}
                                                        dateFormat="dd-MMM-yyyy"
                                                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                                        className="form-control form-control-sm"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        autoComplete="off"
                                                        scrollMonthYearDropdown
                                                        required={true}
                                                        placeholderText="Please Enter Date of Receipt"
                                                    />
                                                </div>
                                            </Ax>
                                        }
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={this.state.updateDispatchFormSubmitting}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={this.state.updateDispatchFormSubmitting}>
                                        Submit {this.state.updateDispatchFormSubmitting ? 
                                            (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Update Remark Modal */}
                <div className="modal fade" id="updateRemarkModal" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Update Remarks</h5>
                                <button
                                    disabled={this.state.remarkSubmitting}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className='p-1 bg-light border-bottom'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "30%" }}>Item ID</td>
                                            <th>{this.state.inventoryItemId || "-"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "30%" }}>Item Name</td>
                                            <th>{this.state.remarkItemFormdata.item_profile ? this.state.remarkItemFormdata.item_profile.name : "-"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "30%" }}>Item Code</td>
                                            <th>{this.state.remarkItemFormdata.item_profile ? this.state.remarkItemFormdata.item_profile.item_code : "-"}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-body">
                                <form className="" id="indentRemark" onSubmit={this.handleRemarkForm}>
                                    <div className="row align-items-center">
                                        <div className="col-sm-12">
                                            <label htmlFor="notes" className="form-label">Remarks</label>
                                            <textarea
                                                name="Remarks"
                                                value={this.state.remarkItemFormdata.remark}
                                                onChange={e => {
                                                    this.setState({
                                                        remarkItemFormdata: { ...this.state.remarkItemFormdata, remark: e.target.value }
                                                    });
                                                }}
                                                className="form-control"
                                                autoComplete='off'
                                                style={{ height: "80px" }}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="modal-footer">
                                    <button disabled={this.state.remarkSubmitting} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button disabled={this.state.remarkSubmitting} type="submit" form='indentRemark' className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Link Indent Modal */}
                <div className="modal fade" id="linkIndentModal" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Link Indent for: {this.state.inventoryItemId ?? "-"}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            {this.state.indent_listing && this.state.indent_listing.length > 0 && 
                                <div className='p-1 bg-light border-bottom'>
                                    <table className='table table-sm mb-0 table-borderless text-sm'>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "26%" }}>Item Name (Code)</td>
                                                <th>{this.state.indent_listing[0] && this.state.indent_listing[0].item ? 
                                                    `${this.state.indent_listing[0].item.name} (${this.state.indent_listing[0].item.item_code})` : "-"}</th>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "26%" }}>Warehouse</td>
                                                <th>{this.state.indent_listing[0] && this.state.indent_listing[0].warehouse ? 
                                                    `${this.state.indent_listing[0].warehouse.name} (${this.state.indent_listing[0].warehouse.code})` : "-"}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            }
                            <form id="linkIndentForm" onSubmit={this.submitLinkIndentForm}>
                                <div className="modal-body">
                                    <table className="table table-bordered table-fixed table-sm align-middle bg-white mt-2">
                                        <thead className="align-middle table-secondary">
                                            <tr className='text-center'>
                                                <th rowSpan={2} style={{ width: "5%" }}>
                                                    <input type='checkbox' onChange={this.checkAllIndentItem} name="chk[]" id="all_check_indent" />
                                                </th>
                                                <th rowSpan={2} style={{ width: "9%" }}>Transaction ID</th>
                                                <th rowSpan={2} style={{ width: "7%" }}>Transaction Date</th>
                                                <th rowSpan={2} style={{ width: "10%" }}>Indent Qty</th>
                                                <th scope="col" style={{ width: "15%" }}>Purchase Qty</th>
                                                <th scope="col" style={{ width: "15%" }}>Pending Qty</th>
                                                <th rowSpan={2} style={{ width: "10%" }}>Transfer Qty</th>
                                            </tr>
                                            <tr className='text-center'>
                                                <th colSpan={2} style={{ width: "15%" }}>Quantity Available to Adjust</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.approved_indent_listing ? 
                                                (<tr><td className="text-center" colSpan={5}><Loader /></td></tr>)
                                                : this.state.indent_listing && this.state.indent_listing.length > 0 ?
                                                    (this.state.indent_listing.map((rowData, k) => {
                                                        return (<tr key={k} className="text-center">
                                                            <td>
                                                                <input
                                                                    type='checkbox'
                                                                    className="indent_item_id_checkbox"
                                                                    value={rowData.wi_item_id}
                                                                    data-purchaseQty={rowData.transfer_qty}
                                                                    data-warehouseItemId={rowData.transaction_id}
                                                                    data-warehouseIndentItemId={rowData.warehouse_indent_item_id}
                                                                />
                                                            </td>
                                                            <td>{rowData.transaction_id}</td>
                                                            <td>{rowData.transaction_date_display}</td>
                                                            <td>{rowData.indent_qty ? rowData.indent_qty : 0}</td>
                                                            <td>{rowData.purchase_qty ? rowData.purchase_qty : 0}</td>
                                                            <td>{rowData.pending_qty ? rowData.pending_qty : 0}</td>
                                                            <td>{rowData.transfer_qty ? rowData.transfer_qty : 0}</td>
                                                        </tr>);
                                                    }))
                                                    : (<tr><td className="text-center" colSpan={5}>No Record Found</td></tr>)
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={this.state.updateDispatchFormSubmitting}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={this.state.updateDispatchFormSubmitting}>
                                        Submit {this.state.updateDispatchFormSubmitting ? 
                                            (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Ax>
        );
    }

    // Render detail content
    renderDetailContent = () => {
        let inventoryTransfer = this.state.inventoryData;
        
        if (this.state.detail_loading) {
            return <Loader />;
        }
        
        if (!inventoryTransfer) {
            return <div className="text-center p-5">No inventory transfer selected</div>;
        }

        let serialNumberCounter = 0;
        const dispatchingDetail = inventoryTransfer?.dispatching_address ? inventoryTransfer.dispatching_address : inventoryTransfer?.warehouse_from_data;

        return (
            <div>
                {/* Header Table */}
                <table className="table table-bordered bg-white">
                    <thead className="table-secondary">
                        <tr>
                            <th style={{ width: "33%" }}>ID</th>
                            <th style={{ width: "33%" }}>Date</th>
                            <th style={{ width: "33%" }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{inventoryTransfer.transaction_id}</td>
                            <td>{inventoryTransfer.transaction_date_display}</td>
                            <td className="align-middle">
                                {inventoryTransfer.status_text ? inventoryTransfer.status_text : ''}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Warehouse Details */}
                <table className="table table-hover table-bordered table-responsive bg-white mb-0">
                    <tbody>
                        <tr>
                            <td style={{ width: "33%" }}>Dispatching Warehouse</td>
                            <td colSpan={2}>
                                {inventoryTransfer.warehouse_from_data ? 
                                    <div>
                                        <b>{inventoryTransfer.warehouse_from_data.name} ({inventoryTransfer.warehouse_from_data.code})</b> <br />
                                        {dispatchingDetail ?
                                            <div className='pt-1'>
                                                {dispatchingDetail.label ? dispatchingDetail.label : ""}<br/>
                                                Address: {dispatchingDetail.address1 ? dispatchingDetail.address1 + ", " : ""}
                                                {dispatchingDetail.address2 ? dispatchingDetail.address2 + ", " : ""}
                                                {dispatchingDetail.landmark ? dispatchingDetail.landmark + ", " : ""}
                                                {dispatchingDetail.city ? dispatchingDetail.city + ". " : "-"} <br />
                                                State: <b>{dispatchingDetail.state_name}</b> <br />
                                                GSTIN: {dispatchingDetail.gstin ?? "-"} <br />
                                            </div> : "-"
                                        }
                                    </div> : "-"
                                }
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "33%" }}>Receiving Warehouse</td>
                            <td colSpan={2}>
                                {inventoryTransfer.warehouse_to_data ?
                                    <div>
                                        <b>{inventoryTransfer.warehouse_to_data.name} ({inventoryTransfer.warehouse_to_data.code})</b>
                                        <br />
                                        <div className="row mt-2">
                                            <div className="col-sm-6">
                                                <div><b>Bill To Address</b></div>
                                                {inventoryTransfer.receiving_address ?
                                                    <div className='pt-1'>
                                                        {inventoryTransfer.receiving_address.label ?
                                                            <span>{inventoryTransfer.receiving_address.label} <br /></span> : ""}
                                                        {inventoryTransfer.receiving_address.address1 ?
                                                            <span>{inventoryTransfer.receiving_address.address1}, <br /></span> : ""}
                                                        {inventoryTransfer.receiving_address.address2 ?
                                                            <span>{inventoryTransfer.receiving_address.address2}, <br /></span> : ""}
                                                        {inventoryTransfer.receiving_address.landmark ?
                                                            <span>{inventoryTransfer.receiving_address.landmark}, <br /></span> : ""}
                                                        {inventoryTransfer.receiving_address.city ?
                                                            <span>{inventoryTransfer.receiving_address.city}, <br /></span> : ""}
                                                        {inventoryTransfer.receiving_address && inventoryTransfer.receiving_address.state_name ?
                                                            <span>State: <b>{inventoryTransfer.receiving_address.state_name}</b> <br /></span> : ""}
                                                        {inventoryTransfer.receiving_address && inventoryTransfer.receiving_address.gstin ?
                                                            <span>GSTIN: <b>{inventoryTransfer.receiving_address.gstin}</b> <br /></span> : ""}
                                                    </div> : "-"}
                                            </div>
                                            <div className="col-sm-6">
                                                <div><b>Ship To Address</b></div>
                                                {inventoryTransfer.shipping_address ?
                                                    <div className='pt-1'>
                                                        {inventoryTransfer.shipping_address.label ?
                                                            <span>{inventoryTransfer.shipping_address.label} <br /></span> : ""}
                                                        {inventoryTransfer.shipping_address.address1 ?
                                                            <span>{inventoryTransfer.shipping_address.address1}, <br /></span> : ""}
                                                        {inventoryTransfer.shipping_address.address2 ?
                                                            <span>{inventoryTransfer.shipping_address.address2}, <br /></span> : ""}
                                                        {inventoryTransfer.shipping_address.landmark ?
                                                            <span>{inventoryTransfer.shipping_address.landmark}, <br /></span> : ""}
                                                        {inventoryTransfer.shipping_address.city ?
                                                            <span>{inventoryTransfer.shipping_address.city}, <br /></span> : ""}
                                                        {inventoryTransfer.shipping_address && inventoryTransfer.shipping_address.state_name ?
                                                            <span>State: <b>{inventoryTransfer.shipping_address.state_name}</b> <br /></span> : ""}
                                                        {inventoryTransfer.shipping_address && inventoryTransfer.shipping_address.gstin ?
                                                            <span>GSTIN: <b>{inventoryTransfer.shipping_address.gstin}</b> <br /></span> : ""}
                                                    </div> : null}
                                            </div>
                                        </div>
                                    </div> : "-"}
                            </td>
                        </tr>
                        <tr>
                            <td>Invoice Number & Date</td>
                            <td style={{ width: "33%" }} className="text-capitalize">{inventoryTransfer.invoice_number ?? "-"}</td>
                            <td style={{ width: "34%" }}>{inventoryTransfer.invoice_date_display ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Logistic Details</td>
                            <td colSpan={2}>
                                {inventoryTransfer.logistic_edd_data && inventoryTransfer.logistic_edd_data.length > 0 && 
                                    inventoryTransfer.logistic_edd_data.map((d, k) => {
                                        return <div key={k}>
                                            <Link onClick={() => this.logisticDetailModal(d.transaction_id)}>
                                                {d.transaction_id} (EDD: {d.delivery_date ? DateService.dateFormat(d.delivery_date) : 'NA'})
                                            </Link>
                                        </div>
                                    })}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Additional Attributes */}
                <div className="tab_content_wrapper my-2">
                    <span className="content_heading">Additional Attributes</span>
                </div>
                <table className="table mt-2 table-hover table-bordered">
                    <tbody>
                        {inventoryTransfer?.additional_attribute_data && inventoryTransfer.additional_attribute_data.length > 0 ?
                            inventoryTransfer.additional_attribute_data.map((attr) => {
                                let displayValue = attr?.value ? attr.value : "-";
                                if (attr.type === 'datetime') {
                                    displayValue = DateService.dateFormat(attr.value, 'DD-MMM-YYYY HH:mm:ss');
                                } else if (attr.type === 'date') {
                                    displayValue = DateService.dateFormat(attr.value, 'DD-MMM-YYYY');
                                }
                                return (<tr key={attr.key}>
                                    <td style={{ width: "33%" }} className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                    <th style={{ width: "66%" }}>{displayValue}</th>
                                </tr>)
                            }) : null}
                    </tbody>
                </table>

                {/* Items Table */}
                <table className="table table-hover table-bordered table-responsive bg-white my-3 table-fixed" id="poTable">
                    <thead className="table-secondary">
                        <tr>
                            <th style={{ "width": '5%' }} className="text-center">
                                <input type='checkbox' onChange={this.checkAllCancelItem} name="chk[]" id="all_check_po" />
                            </th>
                            <th style={{ width: "32%" }}>Item Details</th>
                            <th style={{ width: "10%" }} className="text-center">Indent</th>
                            {this.props.isc_configuration?.track_batch_expiry == "Y" ?
                                <th style={{ width: "21%" }} className="text-center">Batch Number & <br /> Expiry Date</th>
                                : null}
                            <th style={{ width: "8%" }} className="text-end">Quantity</th>
                            <th style={{ width: "8%" }} className="text-end">Unit Rate</th>
                            <th style={{ width: "8%" }} className="text-end">Tax</th>
                            <th style={{ width: "8%" }} className="text-end">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                    
                        {inventoryTransfer && inventoryTransfer.transfer_items && inventoryTransfer.transfer_items.length > 0 ? 
                            inventoryTransfer.transfer_items?.map((i, k) => {
                                return (i.warehouse_indents || []).map((indent, rk) => {
                                    let total_qty = indent.items && indent.items.length > 0 && indent.items.map(s => s.qty).reduce((a, b) => a + b, 0);
                                    let total_rate = indent.items && indent.items.length > 0 ? indent.items[0].rate : 0;
                                    let remark = indent.items && indent.items.length > 0 ? indent.items[0].remark : '';
                                    serialNumberCounter++;
                                    let itemIds = indent.items.map(item => item.id).join(',');
                                    return (<tr key={`${k}-${rk}`}>
                                        <td className='text-center'>
                                            {serialNumberCounter} <br /> <br />
                                            <input
                                                type='checkbox'
                                                className="inventory_item_id_checkbox"
                                                value={i.item_profile.id}
                                                data-indentId={indent.indent_transaction_id ? indent.indent_transaction_id : null}
                                                data-purchaseQty={total_qty}
                                                data-totalRate={total_rate}
                                                data-itemIds={itemIds}
                                            />
                                        </td>
                                        <td className="text-start">
                                            {i.item_profile && <div className='row'>
                                                <div className='col-sm-10'>
                                                    <ItemViewInList item={i.item_profile} remark={remark} viewItemModal={() => this.viewItemModalInit(i.item_profile)} />
                                                </div>
                                                <div className='col-sm-2 text-end'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="px-2" data-bs-toggle="dropdown" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <li className='dropdown-item py-1' onClick={() => this.updateRemarksModalInit(indent, i.item_profile)}>
                                                            <button type='button' className='btn btn-link text-start text-decoration-none w-100 text-dark mx-0'>Update Remarks</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>}
                                        </td>
                                        <td className="text-center link-primary cursor_pointer" onClick={() => this.viewIndentDetailModalInit(indent.indent_transaction_id)}>
                                            {indent.indent_transaction_id ? indent.indent_transaction_id : "-"}
                                        </td>
                                        {this.props.isc_configuration?.track_batch_expiry == "Y" ?
                                            <td className='text-center'>
                                                {indent.items && indent.items.length > 0 ?
                                                    indent.items.map((itemData, idx) => {
                                                        return (
                                                            <div key={idx}>
                                                                {itemData.batch_number && itemData.expiry_date_display ? 
                                                                    <span>{itemData.batch_number} & {itemData.expiry_date_display}</span> : 
                                                                    itemData.batch_number && !itemData.expiry_date_display ? 
                                                                    <span>{itemData.batch_number}</span> : 
                                                                    !itemData.batch_number && itemData.expiry_date_display ? 
                                                                    <span>{itemData.expiry_date_display}</span> : 
                                                                    <span>BNA <sup>#</sup></span>} : <b> {itemData.qty}</b>
                                                            </div>
                                                        )
                                                    }) : null}
                                            </td> : null}
                                        <td className='text-end'> 
                                            {indent.items && indent.items.length > 0 && indent.items.map(s => s.qty).reduce((a, b) => a + b, 0)}
                                            {i.item_profile.measuring_unit && i.item_profile.measuring_unit.name ? 
                                                <span className="text-helping input-group-text text-end pr0">{i.item_profile?.measuring_unit?.name}</span> : null}
                                        </td>
                                        <td className='text-end'>{indent.items && indent.items.length > 0 ? indent.items[0].rate : 0}</td>
                                        <td className='text-end'>
                                            {indent.items && indent.items.length > 0 ? indent.items[0].gst : 0} %
                                            {inventoryTransfer && inventoryTransfer.warehouse_from_data?.gstin ? 
                                                <span className="text-helping input-group-text text-end pr0">
                                                    {inventoryTransfer.dispatching_address && inventoryTransfer.receiving_address ? 
                                                        (inventoryTransfer.dispatching_address?.state_id == inventoryTransfer.receiving_address?.state_id) ? "GST" : "IGST"
                                                        : inventoryTransfer.warehouse_to_data && inventoryTransfer.warehouse_to_data?.state_id == inventoryTransfer?.warehouse_from_data?.state_id ? "GST" : "IGST"}
                                                </span> : null
                                            }
                                        </td>
                                        <td className='text-end'>
                                            <CurrencyFormatter currencyCode={this.props.default_currency} amount={total_qty * total_rate} />
                                        </td>
                                    </tr>)
                                })
                            }) : <tr><td className='text-center' colSpan={8}>No Record</td></tr>
                        }
                    </tbody>
                </table>

                {/* Notes and Totals */}
                <div className="row align-items-center">
                    <div className="col-6">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <div>{inventoryTransfer.notes ?? "-"}</div>
                    </div>
                    <div className="col-6">
                        <table className="table table-borderless">
                            <tbody>
                                <tr className="subtotal_bg_color">
                                    <th>Sub-Total</th>
                                    <td className='float-end'>
                                        {inventoryTransfer.total_amount ? 
                                            <CurrencyFormatter currencyCode={this.props.default_currency} 
                                                amount={(parseFloat(inventoryTransfer.total_amount) - (parseFloat(inventoryTransfer.adjustment_amount ?? 0.0) + parseFloat(inventoryTransfer.total_tax))).toFixed(2)} /> : 0.00}
                                    </td>
                                </tr>
                                {inventoryTransfer.tax_slabs && inventoryTransfer.tax_slabs.length > 0 ?
                                    (inventoryTransfer.tax_slabs.map((ps, k) => {
                                        return <tr className="subtotal_bg_color" key={k}>
                                            <th>{ps.key}</th>
                                            <td className="text-end">{ps.value}</td>
                                        </tr>
                                    })) : null
                                }
                                <tr className="subtotal_bg_color">
                                    <th>Adjustment</th>
                                    <td className='float-end'>{inventoryTransfer.adjustment_amount ?? 0}</td>
                                </tr>
                                <tr className="subtotal_bg_color">
                                    <th>Final Total</th>
                                    <td className='float-end'>
                                        {inventoryTransfer.total_amount ? 
                                            <CurrencyFormatter currencyCode={this.props.default_currency} amount={inventoryTransfer.total_amount} /> : 0}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Dispatching Details */}
                <div className="tab_content_wrapper my-1">
                    <span className="content_heading">Dispatching Details</span>
                    <div className='text-end'>
                        <Link role="button" className="link-primary" onClick={this.updateDispatchModalInit}>
                            <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Update Dispatch Detail
                        </Link>
                    </div>
                </div>
                <table className="table table-hover table-bordered table-responsive bg-white my-3">
                    <tbody>
                        <tr>
                            <td style={{ width: "33%" }}>Eway Bill Number</td>
                            <th style={{ width: "20%" }} className="text-capitalize">{inventoryTransfer.eway_number ?? "-"}</th>
                            <td>Eway Bill Date</td>
                            <th style={{ width: "25%" }}>{inventoryTransfer.eway_date_display ?? "-"}</th>
                        </tr>
                        <tr>
                            <td>Docket Number</td>
                            <th className="text-capitalize">{inventoryTransfer.document_number ?? "-"}</th>
                            <td>Docket Date</td>
                            <th>{inventoryTransfer.document_date_display ?? "-"}</th>
                        </tr>
                        <tr>
                            <td>Transporter Name</td>
                            <th className="text-capitalize">{inventoryTransfer.transporter_number ? inventoryTransfer.transporter_number : "-"}</th>
                            <td>Vehicle No</td>
                            <th>{inventoryTransfer.vechicle_registration_no ? inventoryTransfer.vechicle_registration_no : "-"}</th>
                        </tr>
                        <tr>
                            <td>Number of Boxes</td>
                            <th className="text-capitalize">{inventoryTransfer.no_of_boxes ? inventoryTransfer.no_of_boxes : "-"}</th>
                            <td>Weight</td>
                            <th>{inventoryTransfer.weight ? inventoryTransfer.weight : "-"} {inventoryTransfer.unit_of_weight ? inventoryTransfer.unit_of_weight : ""}</th>
                        </tr>
                        <tr>
                            <td>Date of Dispatch</td>
                            <th className="text-capitalize">{inventoryTransfer.date_of_dispatch ? DateService.dateTimeFormat(inventoryTransfer.date_of_dispatch, 'DD-MMM-YYYY') : "-"}</th>
                            <td>Date of Receipt</td>
                            <th>{inventoryTransfer.date_of_receive ? DateService.dateTimeFormat(inventoryTransfer.date_of_receive, 'DD-MMM-YYYY') : "-"}</th>
                        </tr>
                    </tbody>
                </table>

                {/* Documents */}
                <InventoryTransferDocument 
                    inventoryDetails={inventoryTransfer} 
                    getInventoryTransferDetail={(id) => this.getInventoryTransferDetail(id)} 
                />

                {/* Comments */}
                <div>
                    <div className="tab_content_wrapper mt-3" ref={this.commentRef}>
                        <span className="content_heading">Comments & History</span>
                    </div>
                    
                    <form onSubmit={this.submitUpdateStatusForm}>
                        <div className="my-3 row">
                            <label className="col-sm-3 col-form-label">Change status to</label>
                            <div className="col-sm-5">
                                <TapSelect
                                    changeEvent={(selectedOption) => {
                                        this.tapSelectChange(selectedOption, 'addCommentForm', 'status', () => {
                                            this.setState({
                                                addCommentForm: { 
                                                    ...this.state.addCommentForm, 
                                                    date_of_dispatch: this.state.addCommentForm.status == 36 ? 
                                                        this.state.addCommentForm.date_of_dispatch : '', 
                                                    date_of_receive: '' 
                                                }
                                            })
                                        });
                                    }}
                                    value={this.state.allAllowedStatus.find(s => s.value == this.state.addCommentForm.status)}
                                    options={this.state.allAllowedStatus}
                                    isSearchable={false}
                                    isDisabled={inventoryTransfer?.status == 36 || !this.props.permissions?.includes('isc-inventory_transfer-status-change')}
                                    placeholder="Please Select Status"
                                />
                            </div>
                        </div>
                        <div className="my-3 row">
                            {(inventoryTransfer.status !== 36 && inventoryTransfer.status !== 35 && (this.state.addCommentForm.status == 35 || this.state.addCommentForm.status == 36)) && 
                                <Ax>
                                    <label className="col-sm-3 col-form-label require">Date of Dispatch</label>
                                    <div className="col-sm-4 add_calender_section">
                                        <DatePicker
                                            selected={this.state.addCommentForm.date_of_dispatch ? moment(this.state.addCommentForm.date_of_dispatch, 'YYYY-MM-DD').toDate() : false}
                                            name="date_of_dispatch"
                                            onChange={(value) => this.formDateHandler('date_of_dispatch', value, 'addCommentForm')}
                                            dateFormat="dd-MMM-yyyy"
                                            maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Date of Dispatch"
                                        />
                                        <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                                    </div>
                                </Ax>
                            }
                            {(inventoryTransfer && inventoryTransfer.status !== 36 && this.state.addCommentForm.status == 36) && 
                                <Ax>
                                    <label className={[this.state.addCommentForm.status == 36 && inventoryTransfer && inventoryTransfer.status == 35 ? 'col-sm-3' : 'col-sm-2', 'col-form-label', 'require'].join(' ')}>
                                        Date of Receipt
                                    </label>
                                    <div className={this.state.addCommentForm.status == 36 && inventoryTransfer && inventoryTransfer.status == 35 ? "col-sm-5 add_calender_section" : "col-sm-3 add_calender_section"}>
                                        <DatePicker
                                            selected={this.state.addCommentForm.date_of_receive ? moment(this.state.addCommentForm.date_of_receive, 'YYYY-MM-DD').toDate() : false}
                                            name="date_of_receive"
                                            onChange={(value) => this.formDateHandler('date_of_receive', value, 'addCommentForm')}
                                            dateFormat="dd-MMM-yyyy"
                                            maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                            minDate={moment(this.state.addCommentForm.date_of_dispatch, 'YYYY-MM-DD').toDate()}
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Date of Receipt"
                                        />
                                        <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                                    </div>
                                </Ax>
                            }
                        </div>
                        <div className="my-2">
                            <label className="form-label">Comments</label>
                            <textarea
                                name="notes"
                                value={this.state.addCommentForm.notes}
                                onChange={(e) => this.formInputHandler(e, 'addCommentForm')}
                                className="form-control"
                                placeholder="Please Add a comment"
                                required
                                style={{ height: "100px" }}
                            />
                        </div>
                        <div className="col-12 text-end">
                            <button type="submit" disabled={this.state.addCommentFormSubmitting} className="btn btn-primary mx-2">
                                Update {this.state.addCommentFormSubmitting ? 
                                    (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        </div>
                    </form>
                </div>
                <hr />
                <div className="my-1">
                    {inventoryTransfer.comments && inventoryTransfer.comments.length > 0 ? 
                        inventoryTransfer.comments.map((c, k) => {
                            return (<Ax key={k}>
                                <div className="row">
                                    {c.msg ? <div className="col-sm-8" dangerouslySetInnerHTML={{ __html: c.msg }} /> : 
                                        <div className='col-sm-8'>-</div>}
                                    <div className="col-sm-4 text-end">
                                        <tapIcon.imageIcon icon={tapIcon.CalenderIcon} className="img-fluid pr-5 fs12" alt="item-action" />
                                        <span> {c.created_at_display}</span>
                                    </div>
                                    <div className="col-sm-8 my-1">{c.notes}</div>
                                </div>
                                <hr />
                            </Ax>);
                        }) : null
                    }
                </div>
            </div>
        );
    }

    // Modal JSX (for modal mode)
    inventoryDetailModalJsx = () => {
        return (
            <div className="modal fade" id="inventoryDetailModal" tabIndex="-1">
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Inventory Transfer Detail: {this.state.inventoryItemId ?? "-"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.renderDetailContent()}
                            {this.renderModals()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.renderAs === 'inline') {
            // Render as inline component (for list view)
            return (
                <div className="inventory-transfer-detail-inline">
                    
                    {this.renderDetailContent()}
                    {this.renderModals()}
                    
                    {/* Child modals */}
                    {!this.props?.openedFrom &&  <IndentDetailModal ref={this.indentDetailRef} />}
                    <LogisticViewModal ref={this.LogisticViewModalRef} />
                    <ItemDetailsModal ref={this.itemDetailsRef} />
                </div>
            );
        }
        
        // Render as modal
        return (
            <div>
                {this.inventoryDetailModalJsx()}
                
                {/* Child modals */}
                {!this.props?.openedFrom && <IndentDetailModal ref={this.indentDetailRef} />}
                <LogisticViewModal ref={this.LogisticViewModalRef} />
                <ItemDetailsModal ref={this.itemDetailsRef} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? 
            state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(InventoryTransferDetail);